import styled from 'styled-components/native';

import { FillAbsolute } from 'components/Containers';

export const Wrapper = styled(FillAbsolute)`
  background-color: white;
`;

export { VerticalScroll } from 'components/VerticalScroll/VerticalScroll';
